import useDomain from '@components/Hooks/useDomain';
import useGlobalState from '@components/Hooks/useGlobalState';
import useParams from '@components/Hooks/useParams';
import useSiteConfig from '@components/Hooks/useSiteConfig';
import Termite from '@divtel/termite';
import { IWidget } from '@src/interfaces';
import React, { useEffect } from 'react';
import { Col, Container as Grid, Row } from 'react-bootstrap';
import Cookies from 'universal-cookie';
import useBodyClass from '../Hooks/useBodyClass';
import Apps from './Apps';
import Focus from './Focus';
import Widgets from './Widgets';
const cookies = new Cookies();

const Dashboard: React.FC = () => {

  // console.log('here')

  useBodyClass(['main-page']);
  const site_config = useSiteConfig();

  useEffect(() => {
    if (site_config) {
      document.title = site_config.title;
    }
  }, [site_config]);

  const [store,] = useGlobalState();
  const params = useParams();
  const { getSubDomain } = useDomain();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [params.widget]);

  const getCurrentWidget = (): IWidget | undefined => {
    return store.widgets?.filter((widget) => {
      return widget.name == params.widget;
    })?.[0];
  }

  const getWidgetsSizeLg = () => {
    return getCurrentWidget()?.size == 'lg'
      ? 12
      : getCurrentWidget()?.size == 'md'
        ? 3
        : 4;
  }

  const getWidgetsSizeXl = () => {
    return getCurrentWidget()?.size == 'lg'
      ? 12
      : getCurrentWidget()?.size == 'md'
        ? 4
        : 5;
  }

  const getFocusSizelg = () => {
    return getCurrentWidget()?.size == 'lg'
      ? 12
      : getCurrentWidget()?.size == 'md'
        ? 9
        : 8;
  }

  const getFocusSizeXl = () => {
    return getCurrentWidget()?.size == 'lg'
      ? 12
      : getCurrentWidget()?.size == 'md'
        ? 8
        : 7;
  }

  return (
    // @ts-ignore
    <Termite app={site_config?.title ?? ''} key={cookies.get('oasis_session' + getSubDomain())}>
      <Grid style={{ paddingTop: 18, maxWidth: 2000 }} fluid>
        <Row>
          <Col lg={getFocusSizelg()} xl={getFocusSizeXl()}>
            {params.widget
              ? (<Focus widget={getCurrentWidget()} />)
              : (<Apps />)}
          </Col>
          <Col lg={getWidgetsSizeLg()} xl={getWidgetsSizeXl()}>
            <Widgets size={getCurrentWidget()?.size} />
          </Col>
        </Row>
      </Grid>
    </Termite>
  );
}

export default Dashboard;